import React         from 'react';
import { Redirect, } from 'react-router-dom';

import './error.scss';

const Error = props => (
    <div className="error-page">
        <div className="content-container">
            { ( props.errors.length > 0 && ( ( props.errors[ 0 ].name === 'InvalidClientError' ) ||
                props.errors[ 0 ].message === '{"error":"Invalid client"}' ) ) ?
                <div>
                    <h2>Oops!</h2>
                    <p>No client was found for the URL that you've provided <strong>{ window.location.protocol }//{ window.location.hostname }</strong> and without that we're not going to be able to get you into the site.  Maybe take a peek at that and see if you typed it right? If you are pretty sure you did then maybe we have a little bit of a problem and we'll get that fixed as quickly as we can.</p>
                </div>
            : ( props.errors.length > 0 ) ?
                <div>
                    <h2>Oops!</h2>
                    <p>Sorry, the site is unavailable. Please try again later.</p>
                </div>
            : ( props.authenticated ) ?
                <Redirect to="/home" push />
            :
                <Redirect to="/login" push />
            }
        </div>
    </div>
);

export default Error;
